/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { AppInfo } from "../models/app-info";
@Injectable({
  providedIn: "root",
})
class ConfigService extends __BaseService {
  static readonly configGetAppInfoPath = "/api/Config/GetAppInfo";
  static readonly configGetApiUrlPath = "/api/Config/GetApiUrl";
  static readonly configGetValidFromUrlPath = "/api/Config/GetValidFromUrl";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  configGetAppInfoResponse(): __Observable<__StrictHttpResponse<AppInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Config/GetAppInfo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AppInfo>;
      })
    );
  }
  configGetAppInfo(): __Observable<AppInfo> {
    return this.configGetAppInfoResponse().pipe(
      __map((_r) => _r.body as AppInfo)
    );
  }
  configGetApiUrlResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Config/GetApiUrl`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  configGetApiUrl(): __Observable<string> {
    return this.configGetApiUrlResponse().pipe(
      __map((_r) => _r.body as string)
    );
  }
  configGetValidFromUrlResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/Config/GetValidFromUrl`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "text",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  configGetValidFromUrl(): __Observable<string> {
    return this.configGetValidFromUrlResponse().pipe(
      __map((_r) => _r.body as string)
    );
  }
}

module ConfigService {}

export { ConfigService };
